/**
 * Phrase puzzles — public-domain idioms, proverbs, and common sayings
 * familiar to the 70-95+ audience. All in wide circulation pre-1928
 * (Bartlett's threshold) or so generic they have no single author.
 *
 * Each item must fit the show's 52-cell board (max ~52 letters + spaces),
 * be all caps with single spaces between words, and avoid hyphens or
 * punctuation (the show typically scrubs those).
 */
export const PHRASES = [
  'A PENNY SAVED IS A PENNY EARNED',
  'EARLY TO BED EARLY TO RISE',
  'BIRDS OF A FEATHER FLOCK TOGETHER',
  'ACTIONS SPEAK LOUDER THAN WORDS',
  'A STITCH IN TIME SAVES NINE',
  'ALL THAT GLITTERS IS NOT GOLD',
  'BETTER LATE THAN NEVER',
  'A PICTURE IS WORTH A THOUSAND WORDS',
  'DONT JUDGE A BOOK BY ITS COVER',
  'EVERY CLOUD HAS A SILVER LINING',
  'GOOD THINGS COME TO THOSE WHO WAIT',
  'HONESTY IS THE BEST POLICY',
  'IF IT AINT BROKE DONT FIX IT',
  'KILL TWO BIRDS WITH ONE STONE',
  'LAUGHTER IS THE BEST MEDICINE',
  'MAKE HAY WHILE THE SUN SHINES',
  'NECESSITY IS THE MOTHER OF INVENTION',
  'PRACTICE MAKES PERFECT',
  'ROME WASNT BUILT IN A DAY',
  'STILL WATERS RUN DEEP',
  'THE EARLY BIRD CATCHES THE WORM',
  'THE PEN IS MIGHTIER THAN THE SWORD',
  'THE PROOF IS IN THE PUDDING',
  'THERES NO PLACE LIKE HOME',
  'TIME HEALS ALL WOUNDS',
  'TWO HEADS ARE BETTER THAN ONE',
  'WHAT GOES AROUND COMES AROUND',
  'WHERE THERES A WILL THERES A WAY',
  'YOU CANT JUDGE A BOOK BY ITS COVER',
  'YOU REAP WHAT YOU SOW',
  'ABSENCE MAKES THE HEART GROW FONDER',
  'BEAUTY IS IN THE EYE OF THE BEHOLDER',
  'CURIOSITY KILLED THE CAT',
  'DONT CRY OVER SPILLED MILK',
  'DONT PUT ALL YOUR EGGS IN ONE BASKET',
  'EVERY DOG HAS ITS DAY',
  'FORTUNE FAVORS THE BOLD',
  'GREAT MINDS THINK ALIKE',
  'HASTE MAKES WASTE',
  'HOPE FOR THE BEST',
  'IT TAKES TWO TO TANGO',
  'KNOWLEDGE IS POWER',
  'LET SLEEPING DOGS LIE',
  'LOOK BEFORE YOU LEAP',
  'MANY HANDS MAKE LIGHT WORK',
  'NEVER LOOK A GIFT HORSE IN THE MOUTH',
  'NO NEWS IS GOOD NEWS',
  'OUT OF SIGHT OUT OF MIND',
  'PATIENCE IS A VIRTUE',
  'SAVE FOR A RAINY DAY',
  'SLOW AND STEADY WINS THE RACE',
  'STRIKE WHILE THE IRON IS HOT',
  'THE GRASS IS ALWAYS GREENER',
  'THE SQUEAKY WHEEL GETS THE GREASE',
  'THERES MORE THAN ONE WAY TO SKIN A CAT',
  'THINK BEFORE YOU SPEAK',
  'TRUTH WILL OUT',
  'WHEN IN ROME DO AS THE ROMANS DO',
  'YOU CANT TEACH AN OLD DOG NEW TRICKS',
  'A WATCHED POT NEVER BOILS',
  'A FRIEND IN NEED IS A FRIEND INDEED',
  'AN APPLE A DAY KEEPS THE DOCTOR AWAY',
  'BARKING UP THE WRONG TREE',
  'BURNING THE MIDNIGHT OIL',
  'CALL IT A DAY',
  'COSTS AN ARM AND A LEG',
  'CUT TO THE CHASE',
  'DOWN TO THE WIRE',
  'EASY AS PIE',
  'FIT AS A FIDDLE',
  'GIVE IT A WHIRL',
  'GO THE EXTRA MILE',
  'HEAR IT THROUGH THE GRAPEVINE',
  'IN A NUTSHELL',
  'JUST WHAT THE DOCTOR ORDERED',
  'KEEP YOUR CHIN UP',
  'LET THE CAT OUT OF THE BAG',
] as const;
